var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("vx-card", [
        _c("h4", { staticClass: "mb-1" }, [
          _vm._v(_vm._s(_vm.$t("campaign.approvals"))),
        ]),
        _c("small", { staticClass: "text-muted d-block mb-3" }, [
          _vm._v(_vm._s(_vm.$t("campaign.approvals_hint"))),
        ]),
        _vm.isLoading
          ? _c("div", { staticClass: "text-center py-4" }, [
              _c("span", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.$t("loading"))),
              ]),
            ])
          : !_vm.pending.length
          ? _c(
              "div",
              { staticClass: "text-center py-4" },
              [
                _c("feather-icon", {
                  staticClass: "h-8 w-8 text-success mb-1",
                  attrs: { icon: "CheckCircleIcon" },
                }),
                _c("p", { staticClass: "text-muted mb-0" }, [
                  _vm._v(_vm._s(_vm.$t("campaign.approvals_empty"))),
                ]),
              ],
              1
            )
          : _c(
              "div",
              _vm._l(_vm.pending, function (c) {
                return _c("div", { key: c.id, staticClass: "approval-row" }, [
                  _c("div", { staticClass: "approval-main" }, [
                    _c("div", { staticClass: "font-medium" }, [
                      _vm._v(_vm._s(c.name)),
                    ]),
                    _c("small", { staticClass: "text-muted d-block" }, [
                      _vm._v(_vm._s(_vm._.get(c, "legal_entity.name"))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "mt-1" },
                      [
                        _c(
                          "vs-chip",
                          {
                            staticClass: "mr-1",
                            attrs: { transparent: "", color: "primary" },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("campaign.discount")) +
                                ": " +
                                _vm._s(
                                  _vm.amountLabel(
                                    c.discount_type,
                                    c.discount_amount
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "vs-chip",
                          {
                            staticClass: "mr-1",
                            attrs: { transparent: "", color: "warning" },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("campaign.commission")) +
                                ": " +
                                _vm._s(
                                  _vm.amountLabel(
                                    c.commission_type,
                                    c.commission_amount
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "vs-chip",
                          { attrs: { transparent: "", color: "dark" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s((c.campaign_products || []).length) +
                                " " +
                                _vm._s(_vm.$t("campaign.products_count")) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    c.briefing
                      ? _c("p", { staticClass: "mt-1 mb-0 text-muted small" }, [
                          _vm._v(_vm._s(c.briefing)),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    { staticClass: "approval-actions" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { size: "sm", variant: "outline-primary" },
                          on: {
                            click: function ($event) {
                              return _vm.openDetail(c)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("campaign.see_detail")) + " "
                          ),
                        ]
                      ),
                      _c(
                        "b-button",
                        {
                          attrs: { size: "sm", variant: "success" },
                          on: {
                            click: function ($event) {
                              return _vm.accept(c)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("campaign.accept")))]
                      ),
                      _c(
                        "b-button",
                        {
                          attrs: { size: "sm", variant: "outline-danger" },
                          on: {
                            click: function ($event) {
                              return _vm.refuse(c)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("campaign.refuse")))]
                      ),
                    ],
                    1
                  ),
                ])
              }),
              0
            ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }